import { atom, selector } from "recoil";
import moment from "moment";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const bagReportListState = atom({
    key: 'bagReportListState',
    default: [],
})

export const bagReportAirlineState = atom({
    key: 'bagReportAirlineState',
    default: [],
})

export const filtersDefault = [
    {
        label: 'Period',
        size: 3,
        required: true,
        type: 'dateRange',
        value: [moment().subtract(1, 'week').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    },
    {
        label: 'Airline',
        size: 2,
        required: true,
        type: 'select',
        value: { label: 'All Airlines', value: 'All' },
        list: [
            { label: 'All Airlines', value: 'All' },
        ]
    },
    {
        label: 'Status',
        size: 2,
        required: true,
        type: 'select',
        value: { label: 'All Status', value: 'All' },
        list: [
            { label: 'All Status', value: 'All' },
            { label: 'TRACING', value: 'TRACING' },
            { label: 'LOCATED', value: 'LOCATED' },
            { label: 'PARTIALLY LOCATED', value: 'PARTIALLY LOCATED' },
            { label: 'RECEIVED', value: 'RECEIVED' },
            { label: 'PARTIALLY RECEIVED', value: 'PARTIALLY RECEIVED' },
            { label: 'DELIVERED', value: 'DELIVERED' },
            { label: 'PARTIALLY DELIVERED', value: 'PARTIALLY DELIVERED' },
            { label: 'FORWARDED', value: 'FORWARDED' },
            { label: 'PARTIALLY FORWARDED', value: 'PARTIALLY FORWARDED' },
            { label: 'FORWARDED/DELIVERED', value: 'FORWARDED/DELIVERED' },
        ]
    },
    {
        label: 'Created by staff',
        name: 'CreatedByUserId',
        size: 3,
        required: false,
        type: 'select',
        value: { label: 'All staff', value: 'All' },
        list: [
            { label: 'All staff', value: 'All' },
        ]
    },
]

/** Bag-level columns only; no case-type-specific fields (no DPR-only, no arriving flight tied to select types). */
export const bagReportDataStructureState = selector({
    key: 'bagReportDataStructureState',
    get: ({ get }) => (
        [
            {
                label: 'Tag number',
                field: 'tag_number',
                type: 'text',
                order: { table: 1 },
                table: { minWidth: 110, maxWidth: 150 },
            },
            {
                label: 'Bag status',
                field: 'bag_status',
                type: 'select',
                order: { table: 2 },
                table: { minWidth: 120, maxWidth: 170 },
                subFields: { label: 'name', value: 'id' },
            },
            {
                label: 'Receive date',
                field: 'receive_date',
                type: 'datepicker',
                order: { table: 3 },
                table: { minWidth: 108, maxWidth: 150, dateFormat: 'DD-MMM-YY' },
            },
            {
                label: 'Received flight',
                field: 'received_flight',
                type: 'text',
                order: { table: 4 },
                table: { minWidth: 110, maxWidth: 150 },
            },
            {
                label: 'Received weight (kg)',
                field: 'received_weight',
                type: 'text',
                order: { table: 4.5 },
                table: { minWidth: 100, maxWidth: 130 },
            },
            {
                label: 'Deliver date',
                field: 'deliver_date',
                type: 'datepicker',
                order: { table: 5 },
                table: { minWidth: 130, maxWidth: 155, dateFormat: 'HH:mm | DD-MMM-YY' },
            },
            {
                label: 'Delivery name',
                field: 'delivery_name',
                type: 'text',
                order: { table: 6 },
                table: { minWidth: 120 },
            },
            {
                label: 'Delivery contact',
                field: 'delivery_contact',
                type: 'text',
                order: { table: 7 },
                table: { minWidth: 110 },
            },
        ].filter((v) => {
            const page = get(pageState)
            const permissions = get(permissionState)
            if (!v.permission) {
                return true
            }
            let absolute = false;
            if (v.permission.substr(0, 1) === ":") {
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
